module.exports = __webpack_public_path__ + "img/decrease.a0a722da.svg";